module.exports = __webpack_public_path__ + "media/dark-tour.7210c14f.mp4";